import React from "react";
import { AreaChart, Area, ResponsiveContainer, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { Spinner } from 'react-bootstrap';

const cdata = [
    { index: 10000, Data1: 1643, Data2: 790 },
    { index: 1666, Data1: 182, Data2: 42 },
    { index: 625, Data1: 56, Data2: 11 },
    // Calculation of line of best fit is not included in this demo
    { index: 300, Data1: 0 },
    { index: 10000, Data2: 1522 },
    { index: 600, Data1: 0 },
    { index: 10000, Data2: 678 }
];

const CustomTooltip = ({ active, payload, label }) => {
    // debugger;
    if (active && payload && payload.length) {
        return (
            <div className="custom-tooltip">
                <div>{payload[0].payload.serviceType}</div>
                <div className="tooltipTitle_blue">Bill Count : {payload[0].value} </div>
                <div className="tooltipTitle_yellow">Average Character Count : {payload[1].value}</div>
            </div>
        );
    }

    return null;
};

const CustomSpinner = () => {
    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <MySpinner />
                    <div className="card-header blue-heading">
                    Top Average Character Count by Service Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const RenderChart = ({ data }) => {

    let rows = [];

    if (data.length > 0) {
        data.map((row) => {

            let newRow = [];

            if (data.length > 0) {
                newRow = {
                    "serviceType": row.serviceType,
                    "billCount": row.billCount,
                    "averageCharacterCount": row.averageCharacterCount
                }
                rows = [...rows, newRow];
            }
        })
    }

    return (
        <>
            <div className='col-md-6 col-xs-12 col-lg-4 col-sm-12'>
                <div className="card">
                    <div className="card-header blue-heading">
                    Top Average Character Count by Service Type
                    </div>
                    <div className="card-body search-form">
                        <div style={{ width: '100%' }} className='set-height'>
                            <ResponsiveContainer>
                                <AreaChart
                                    width={500}
                                    height={500}
                                    data={rows}
                                    margin={{
                                        top: 10,
                                        right: 30,
                                        left: 0,
                                        bottom: 0
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="serviceType" />
                                    <YAxis />
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend />
                                    <Area
                                        type="monotone"
                                        dataKey="billCount"
                                        name="Bill Count"
                                        stackId="1"
                                        stroke="#1f79a4"
                                        fill="#1f79a4"
                                    />
                                    <Area
                                        type="monotone"
                                        dataKey="averageCharacterCount"
                                        name="Average Character Count"
                                        stackId="2"
                                        stroke="#eac205"
                                        fill="#eac205"
                                    />

                                </AreaChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

const MySpinner = () => {
    return (
        <Spinner className='spinner-border spinner-border-chart' />
    )
}

export default function TopProviderByCharacterCount({ data, loading }) {
    if (loading) {
        return <CustomSpinner />
    }

    return <RenderChart data={data} />
}